<template>
<div class="clinic-menu">
  <ul class="menu-option" style="width: 180px;">
    <li :class="{'menu-item':true,'active':key===selIndex && selShow,'sel-item':key===selIndex}" v-for="(item,key) in menu" :key="key">
      <div class="menu-item-title" @click="changeIndex(key)">
        <span class="menu-item-left">
          <i :class="'iconfont '+(item.thumb?item.thumb:'')" style="margin-right: 10px"></i>
          <span class="item-label">{{item.title}}</span>
        </span>
        <i v-if="item.children.length" class="menu-item-icon iconfont icon-xiala1"></i>
      </div>
      <ul class="children">
        <li :class="{'children-item':true,'sel-title':childIndex===index}" v-for="(items,index) in item.children" :key="index" @click="changeChildren(index)">
          <a class="children-item-title" href="javascript:;">{{items.title}}</a>
        </li>
      </ul>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "ClinicMenu",
  data(){
    return{
      menu:[],
      selIndex:0,
      selShow:false,
      childIndex:0
    }
  },
  created() {
    this.init()
  },
  methods:{
    init(){
      var that = this
      this.requestApi('/clinic/get_clinic_menu').then(function (res) {
        if (res.status){
          that.menu = res.data
          let selIndex = Number(sessionStorage.getItem('clinicSelIndex'))
          that.selIndex = selIndex?selIndex:0
          let childIndex = Number(sessionStorage.getItem('clinicChildIndex'))
          that.childIndex = childIndex?childIndex:0
          if(that.menu[childIndex]) {
            that.selShow = true
          }
          if(that.selIndex == 0 && that.childIndex == 0) {
            //默认显示第一个路由
            for(let i in res.data) {
              if(res.data[i].children.length != 0) {
                that.toUrl(res.data[i].children[0].path)
                break
              }else {
                that.toUrl(res.data[i].path)
                break
              }
            }
          }
        }
      })
    },
    changeIndex(key){
      if (this.selIndex === key) {
        this.selShow = !this.selShow
        return false
      }
      this.childIndex = 0
      var path = ''
      if(this.menu[key].children.length) path = this.menu[key].children[0].path
      else path = this.menu[key].path
      this.selShow  = true
      this.selIndex = key
      sessionStorage.setItem('clinicSelIndex',key)
      sessionStorage.setItem('clinicChildIndex',0)
      this.toUrl(path)
    },
    changeChildren(index){
      var item = this.menu[this.selIndex]
      this.childIndex = index
      sessionStorage.setItem('clinicChildIndex',index)
      this.toUrl(item.children[index].path)
    }
  }
}
</script>

<style scoped>
  .iconfont{
    font-size: 14px;
    color: #666;
  }
  .clinic-menu{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    overflow-y: auto;
    background: #fff;
    border-right: 1px solid rgb(232, 232, 232);
    z-index: 100;
  }
  .active .children{
    display: block!important;
  }
  .sel-item .menu-item-title{
    color: #c09351;
  }
  .sel-item .menu-item-left .iconfont{
    color: #c09351!important;
  }
  .menu-item-title{
    padding: 0 35px 0 20px;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }
  .menu-item-left{
    display: flex;
	align-items: center;
  }
  .menu-item-icon{
    position: absolute;
    top: 0;
    right: 16px;
    transition: all .3s;
  }
  .active .menu-item-icon{
    transform: rotate(180deg);
  }
  .children{
    display: none;
  }
  .children-item{
    padding-left:40px;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
  .children-item-title{
    color: #000000;
  }
  .sel-title{
    background: #c09351;
  }
  .sel-title .children-item-title{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/ClinicMenu.vue